// reducers/stepperSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addProtection: {
    // `pai` is gone: Personal Accident Insurance was withdrawn from sale, so
    // there is no state for it to be switched back on. A stale persisted value
    // is inert — the payload no longer reads it and the server refuses the type.
    cdw: false,
    scdw: false,
    baby_seat: false,
    gps: false,
    driver: false,
    activeKM: null,
    extra_km : null
  },
};

const addProtectionSlice = createSlice({
  name: "addProtection",
  initialState,
  reducers: {
    setAddProtection: (state, action) => {
      state.addProtection = { ...state.addProtection, ...action.payload };
    },
    resetAddProtection: (state) => {
      state.addProtection = initialState.addProtection;
    },
  },
});

export const { setAddProtection, resetAddProtection } =
  addProtectionSlice.actions;
export default addProtectionSlice.reducer;
